import { Action, Reducer } from "redux";
import { BodyshopState, BodyshopTypes, BodyshopActionTypes } from "./bodyshopTypes";
import { haskeyReducer, updateGetIsolated, updateSaveIsolated } from "@/main/services/reducerUtils";

export const INITIAL_STATE: BodyshopState = {
	bodyshops: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	isolated: {},
};

const bodyshopReducer: Reducer<BodyshopState> = (state: BodyshopState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as BodyshopActionTypes;
	switch (actionTypes.type) {
		case BodyshopTypes.GET_BODYSHOPS: {
			const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducer) return updateGetIsolated(state, actionTypes);

			return {
				...state,
				bodyshops: { ...state.bodyshops, isLoading: true },
			};
		}
		case BodyshopTypes.SAVE_BODYSHOPS: {
			const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducerSave) return updateSaveIsolated(state, actionTypes);

			return {
				...state,
				bodyshops: {
					...state.bodyshops,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		}
		case BodyshopTypes.RESET_REDUCER_BODYSHOPS:
			return {
				...state,
				bodyshops: INITIAL_STATE.bodyshops,
			};
		default:
			return state;
	}
};

export default bodyshopReducer;
